import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ItemNote } from '../_models/itemNote';
import { PlanItem } from '../_models/planItem';

@Injectable({
  providedIn: 'root'
})
export class ItemNoteService {

  baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

    updateItemNote(planItemId: number, itemNotes: ItemNote[], uploadedMP4s: File[]): Observable<string[]> {
      var url = this.baseUrl + 'note';

      const formData = new FormData();

      formData.append("PlanItemId", new Blob([planItemId + ''], { type: "application/json" }));
      let minNoteList: ItemNote[] = [];
      itemNotes.forEach(note => {
        const minNote: ItemNote = { id: note.id, planItemId: note.planItemId, memberId: note.memberId, member: null, toId: note.toId, to: null, value: note.value, noteType: note.noteType };
        minNoteList.push(minNote);
      });

      if (minNoteList.length > 0) {
        formData.append("jsonData", new Blob([JSON.stringify(minNoteList)], { type: "application/json" }));
      }
      uploadedMP4s.forEach(mp4 => {
        formData.append("files", mp4);
      });

      return this.http.post<string[]>(url, formData);
    }
}
